const aboutlending = {
    "About Lendingkart": [
        {
        question: "What is the business of Lendingkart Finance Limited (Lendingkart or LFL)?",
        answer: "Lendingkart is a registered as a non-deposit taking NBFC and is engaged in providing unsecured small and medium-sized enterprise (SME) loans since 2015. " +
         "The Company operates through offices in Ahmedabad, Bangalore and Mumbai and serves across India. " + "<br /><br />" +
         "The lending principle for the company is based on a branch less model with credit evaluation " +
        "using a proprietary scoring model with minimum human interface." + "<br /><br />" + 
        "It caters to the loan requirements of MSME borrowers across various Industries and sectors"+
        "with loan sizes ranging between INR 50,000 to INR 35 lakhs on an average. These working" +
        "capital business loans are offered for a tenure of up to 36 months. Lendingkart offerings are" +
        "largely to the customer segment that is under served by traditional financial institutions."      
        },
        {
          question: "Who are the investors in Lendingkart?",
          answer: "Lendingkart Technologies Private Limited (LTPL), the technology arm of the Group, holds a " +
          "100% stake in LFL. The Group was started in 2014 by one of the co-founders, Mr. " +
          "Harshvardhan Lunia, who holds ~6% in LTPL. Fullerton is the largest shareholder in LTPL with " +
          "a ~40% stake in LTPL."
        },
        {
            question: "What are the strengths of Lendingkart?",
            answer: `<ul>
            <li>Strong Investors – Investors like Fullerton (40%), Bertelsmann India (12%), Mayfield (11%), Saama capital (8%) are investors in Fullerton Technologies (LTPL) which holds 100% shareholding in Lendingkart.</li>
            <li>Healthy Capitalization - The Capital Adequacy Ratio (CRAR) is 36.0% which is significantly higher than RBI minimum limit of 15%</li>
            <li>Strong Asset Quality - The company has a low GNPA of 1.8% and NNPA of 0.8% as on 31st Mar’23.</li>
            <li>Diversified Lending Portfolio - Portfolio spread across 25+ sectors and 100+ sub-sectors with no sector contributing more than 12% with a total 225K borrowers.</li>
            <li>Consistent Profitability - The company has posted a profit in all the last 6 quarters with PAT of Rs. 116 Cr for FY23.</li>
            <li>Diversified Borrowing - Well-diversified borrowing profile spread across ~60 lenders including Public/ Private Sector Banks, NBFCs, AIFs and FPIs which include SBI, Kotak Bank, ICICI Bank, SIDBI amongst others.</li>
            </ul>`
          },
          {
            question: "What are the major risks to Lendingkart?",
            answer: "-  Moderate Borrower profile – Lendingkart caters to the MSME segment, which is highly vulnerable to downturns in economic cycles. Further, its entire AUM represents unsecured lending."
          },
          {
            question: "What is the Credit rating for Lendingkart?",
            answer: "Lendingkart is rated BBB+/ Positive outlook by ICRA"
          },
          {
            question: "What is the AUM of Lendingkart?",
            answer: "The AUM as on 31st Mar 2023 is Rs. 4,978 Cr"
          },
          {
            question: "What is the profitability of Lendingkart?",
            answer: "Profit Before Tax (PBT) is Rs. 155 Cr" + "<br>" +
            "Profit After Tax (PAT) is Rs. 116 Cr" + "<br>" +
            "(Data for FY23)"
          },
          {
            question: "How is the asset quality of Lendingkart?",
            answer: "The company has a low GNPA of 1.8% and NNPA of 0.8% in Q4FY23."
          },
          {
            question: "What is the Capital Adequacy ratio? ",
            answer: "The Capital Adequacy Ratio (CRAR) as on 31st Mar’23 is 36.0%."
          },


    ],
}

export default aboutlending;